import React from 'react';

const Toast = ({ children, ...props }) => {
  return (
    <div {...props}>
      {children}
    </div>
  );
};

export default Toast;
